import React, { useState } from 'react';
import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '@iconify/react';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { firestore } from '../../../../contexts/FirebaseContext';

export default function DialogRechazarCancelacion({ data, dialogProp }) {
  const [openDialog, setOpenDialog] = useState(false);
  const { currentUser } = useAuthUsers();

  return (
    <Box>
      <Button
        variant={dialogProp ? dialogProp?.variant || 'contained' : 'contained'}
        size={dialogProp ? dialogProp?.size : 'medium'}
        color="warning"
        onClick={() => setOpenDialog(true)}
      >
        Rechazar cancelacion
      </Button>
      <DialogBody open={openDialog} onClose={setOpenDialog} data={data} userId={currentUser.id} />
    </Box>
  );
}

function DialogBody({ open, onClose, data, userId }) {
  //   const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting }
  } = useForm();

  const handleClose = () => {
    onClose(false);
  };

  const { verifyUserNip } = useAuthUsers();

  const onSubmit = async (dataForm) => {
    if (verifyUserNip(dataForm.nip)) {
      await firestore.collection('cotizaciones').doc(data?.id).update({ state: 'PAGADO' });
      await firestore.collection('mensaje_items').add({
        cretedAt: new Date(),
        itemId: data?.id,
        action: 'PAGADO',
        message: dataForm.message,
        razon: 'solicitud-cancelacion-rechazada'
      });

      reset();
      enqueueSnackbar('Cancelacion rechazada', { variant: 'success' });
      //   setLoading(false);
      handleClose();
    } else {
      enqueueSnackbar('Ingrese NIP correcto', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">¿Está seguro que desea rechazar esta cancelacion?</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(onSubmit)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={isSubmitting} fullWidth variant="contained" type="submit">
            Rechazar cancelacion
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
